import React from "react";
import { scanProduct } from "../../helpers/nativeInterface";
import { Box, Button, Grid, InputBase, useTheme } from "@mui/material";
import CustomTextField from "./CustomTextField";

const CodigoBarrasInput = ({ codigoBarra, setCodigoBarra, onScan, loading = false, disabled = false }) => {
  const theme = useTheme();
  const handleAbrirScanner = () => {
    if (onScan) {
      onScan();
    } else {
    scanProduct();
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <CustomTextField
          label="CÓDIGO ARTÍCULO"
          value={codigoBarra}
          onChange={e => setCodigoBarra(e.target.value)}
          disabled={disabled || loading}
          loading={loading}
          sx={{
            borderRadius: "10px",

            "& .MuiInputBase-input": {
              py: 1.5,
            },
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <Button
          fullWidth
          onClick={handleAbrirScanner}
          disabled={disabled || loading}
          sx={{
            boxShadow: 0,
            fontWeight: "bold",
            color: "black",
            fontSize: 14,
            height: 47,
            backgroundColor: theme.bandera?.colorSecundario || "#004280",
            ":hover": {
              backgroundColor: theme.bandera?.colorSecundario || "#004280",
            },
            ":disabled": {
              backgroundColor: "#cccccc",
              color: "#666666",
            },
          }}
        >
          LEER CÓDIGO
        </Button>
      </Grid>
    </Grid>
  );
};

export default CodigoBarrasInput;
